import { h, ComponentChildren } from 'preact';

interface PublicLayoutProps {
  children: ComponentChildren;
}

export default function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div class="max-w-md w-full">
        {children}
      </div>
    </div>
  );
}
